export function setHomePageData(state, payload) {
    state.coaching_tracks = payload.coaching_tracks
    state.drop_ins = payload.drop_ins
    state.config_api = payload.config_api
    state.quotes = payload.quotes
    state.upcoming_event = payload.upcoming_event
    state.survey_cards = payload.survey_cards
}

export function resetStore(state) {
    state.coaching_tracks = []
    state.config_api = {}
    state.quotes = []
    state.upcoming_event = {}
    state.survey_cards = []
}
